import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import Skeleton from "react-loading-skeleton";
import NoData from "../../../components/Ui/NoData";
import auth from "../../../init.firebase";
import { useGetAllReviewsByEmailQuery } from "../../../redux/products/productsApi";

const ViewReviews = () => {
  const [user] = useAuthState(auth);
  const [haveUser, setHaveUser] = useState(true);

  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user.email]);

  const {
    data: allReviews,
    isLoading,
    isError,
  } = useGetAllReviewsByEmailQuery(user?.email);

  let content = null;
  if (isLoading) {
    content = <Skeleton count={3} />;
  }
  if (!isLoading && isError) {
    content = <p className="text-danger">There is Something wrong!</p>;
  }
  if (!isLoading && !isError && allReviews?.length === 0) {
    content = <NoData />;
  }
  if (!isLoading && !isError && allReviews?.length > 0) {
    content = (
      <div>
        <p>Total Reviews: {allReviews?.length}</p>
        {allReviews?.map((review) => (
          <Row key={review?._id} className="mt-4">
            <Col xs={4} md={2}>
              <Image
                src={`${process.env.REACT_APP_IMAGE_URL}${review?.product?.images?.[0]?.filename}`}
                fluid
              />
            </Col>
            <Col xs={6} md={8}>
              <p className="order_name mb-2">{review?.product?.name}</p>
              <small>
                <span className="fw-semibold">Your comment:</span>{" "}
                {review?.description}
              </small>
            </Col>
            <Col xs={2} md={2}>
              <div className="d-flex align-items-center flex-column mt-0">
                <p>{new Date(review?.createdAt).toLocaleDateString()}</p>
              </div>
            </Col>
          </Row>
        ))}
      </div>
    );
  }

  return (
    <>
      <div>
        <h2 className="text-start">View Reviews</h2>
        <div className="doted-container">{content}</div>
      </div>
    </>
  );
};

export default ViewReviews;
